import {
    bookingNotificationConstants,
    BOOKING_NOTIFICATION_SEEN_LIMIT,
} from "../../../../constants/Booking/bookingNotification.constants";

// Proje zarfi: { status: 200, error: false, message, data }
// Basari "status === 1" ile DEGIL, error bayragiyla anlasilir.
const isOk = (payload) => !!payload && payload.error === false;

const toInt = (value) => {
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
};

// Ayni rezervasyon hem taze listede hem gorulmuslerde olmasin.
const dedupeById = (list) => {
    const seenIds = {};
    return list.filter((row) => {
        if (!row || row.id === undefined || row.id === null) return false;
        if (seenIds[row.id]) return false;
        seenIds[row.id] = true;
        return true;
    });
};

const initialState = {
    fetching: false,
    // Ilk yanit alinana kadar canda iskelet gosterilir.
    initialized: false,
    error: false,

    // Cursor. null = "henuz izlemiyoruz" (istekte after_id HIC gonderilmez).
    cursor: null,
    // Toast cift-tetiklemesini engeller; cursor'dan AYRI tutulur.
    toastedId: 0,

    latestId: 0,
    // Gercek sayi; items en fazla 20 satir olsa da bu 3864 olabilir.
    count: 0,
    items: [],
    // Panel kapatilinca buraya tasinir; tekrar acilinca ekran bos kalmasin diye.
    seen: [],

    // Elimizdeki verinin ait oldugu tesis; degisince cursor sifirlanir.
    propertyId: null,

    toast: null,

    // Ust uste hata sayaci; devre kesiciyi besler (bkz. bookingNotificationActions).
    failures: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case bookingNotificationConstants.BOOKING_NOTIFICATIONS_PENDING:
            // Liste titremesin diye items/count'a dokunmuyoruz.
            return {
                ...state,
                fetching: true,
            };

        case bookingNotificationConstants.BOOKING_NOTIFICATIONS_FULFILLED: {

            const payload = action.payload;

            // HTTP 200 ama error:true olabilir (yetki, parametre) — hata sayilir.
            if (!isOk(payload)) {
                return {
                    ...state,
                    fetching: false,
                    initialized: true,
                    error: payload,
                    failures: state.failures + 1,
                };
            }

            const meta = action.meta || {};
            const data = payload.data || {};

            const latestId = toInt(data.latest_id);
            const count = toInt(data.count);
            const items = Array.isArray(data.items) ? data.items : [];

            // Tesis degistiyse eldeki cursor baska bir tesise ait; sifirdan izle.
            const propertyChanged = meta.propertyId !== state.propertyId;
            const isFirstCall = state.cursor === null || propertyChanged;

            if (isFirstCall) {
                return {
                    ...state,
                    fetching: false,
                    initialized: true,
                    error: false,
                    propertyId: meta.propertyId !== undefined ? meta.propertyId : state.propertyId,
                    latestId: latestId,
                    // Ilk cagrida rozet daima 0 — gecmis yigin bildirim degildir.
                    count: 0,
                    items: [],
                    seen: propertyChanged ? [] : state.seen,
                    // latest_id 0 ise (yetkili tesis/rezervasyon yok) cursor'u
                    // acmayiz; ilk rezervasyon dustugunde izleme oradan baslar.
                    cursor: latestId > 0 ? latestId : null,
                    toastedId: latestId > 0 ? latestId : state.toastedId,
                    toast: null,
                    failures: 0,
                };
            }

            const shouldToast = count > 0 && latestId > state.toastedId;

            return {
                ...state,
                fetching: false,
                initialized: true,
                error: false,
                latestId: latestId,
                count: count,
                items: items,
                toastedId: shouldToast ? latestId : state.toastedId,
                toast: shouldToast
                    ? {latestId: latestId, count: count, item: items[0] || null}
                    : state.toast,
                failures: 0,
            };
        }

        case bookingNotificationConstants.BOOKING_NOTIFICATIONS_REJECTED:
            // Ag hatasi gecici olabilir; eldeki listeyi silmiyoruz.
            return {
                ...state,
                fetching: false,
                initialized: true,
                error: action.payload,
                failures: state.failures + 1,
            };

        // Menu KAPANINCA: cursor ilerler, rozet siter, satirlar "gorulmus"e tasinir.
        case bookingNotificationConstants.BOOKING_NOTIFICATIONS_MARK_SEEN: {

            if (state.count === 0 && state.items.length === 0) {
                return state;
            }

            return {
                ...state,
                cursor: state.latestId > 0 ? state.latestId : state.cursor,
                toastedId: Math.max(state.toastedId, state.latestId),
                count: 0,
                items: [],
                seen: dedupeById([...state.items, ...state.seen]).slice(0, BOOKING_NOTIFICATION_SEEN_LIMIT),
            };
        }

        case bookingNotificationConstants.BOOKING_NOTIFICATIONS_TOAST_CLEAR:
            return {
                ...state,
                toast: null,
            };

        case bookingNotificationConstants.BOOKING_NOTIFICATIONS_RESET:
            return {
                ...initialState,
            };

        case "CLEAR_STATE":
            return {
                ...initialState,
            };

        default:
            return state;
    }
}
